// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_kj-0";
export var discountCodeInput = "_kj-1";